/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgramRange = exports.getChannelRange = exports.findFirstProgramForCoordinate = exports.collectProgramsFromCoordinateData = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _coordinateUtils = require("./coordinateUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var collectProgramsFromCoordinateData = function collectProgramsFromCoordinateData(coordinateData) {
  if (!coordinateData) {
    return undefined;
  }
  var yKeys = Object.keys(coordinateData).sort();
  var data = yKeys.reduce(function (yAxisAcc, y) {
    var yAxisData = coordinateData[y];
    var xKeys = Object.keys(yAxisData).sort();
    var xData = xKeys.reduce(function (xAxisAcc, x) {
      var xAxisData = yAxisData[x];
      var channels = (0, _get2["default"])(xAxisData, 'data.content.channels');
      if (!channels) {
        return xAxisAcc;
      }
      return channels.reduce(function (acc, channel, channelIndex) {
        acc[channelIndex] = [].concat(_toConsumableArray(acc[channelIndex] || []), _toConsumableArray(channel.programs.map(function (p) {
          return _objectSpread(_objectSpread({}, p), {}, {
            tileId: "".concat(p.id, "_").concat(x, "_").concat(y)
          });
        })));
        return acc;
      }, xAxisAcc);
    }, []);
    return [].concat(_toConsumableArray(yAxisAcc || []), _toConsumableArray(xData));
  }, []);
  return data;
};
exports.collectProgramsFromCoordinateData = collectProgramsFromCoordinateData;
var findFirstProgramForCoordinate = function findFirstProgramForCoordinate(coordinateData, coordinate, dataRange) {
  var programData = collectProgramsFromCoordinateData(coordinateData);
  var _coordinateToDataRang = (0, _coordinateUtils.coordinateToDataRange)(coordinate, dataRange),
    xFrom = _coordinateToDataRang.xFrom,
    yFrom = _coordinateToDataRang.yFrom;
  var channelIndex = Math.floor(yFrom);
  var selectedChannel = programData[channelIndex];
  if (!selectedChannel) {
    return undefined;
  }
  var orderedPrograms = selectedChannel.slice().sort(function (a, b) {
    return a.startTime - b.startTime;
  });
  return orderedPrograms.find(function (program) {
    return program.startTime >= xFrom;
  });
};

/**
 * Mapping a program object's startTime and endTime
 * to a coordinate grid X range (```{ xFrom, xTo }```)
 * Using the current coordinate to calculate where
 * we are in the global grid.
 *
 * @memberof ProgramGuideTile
 *
 * @param {Program} program Program object to get the grid range from.
 * @param {object} range The total range
 * @param {object} coordinate The current coordinate
 * @returns {object} The coordinate grid X range (```{ xFrom, xTo }```)
 *                   for the given program.
 */
exports.findFirstProgramForCoordinate = findFirstProgramForCoordinate;
var getProgramRange = function getProgramRange(program, range, coordinate) {
  var startTime = range.xFrom,
    endTime = range.xTo;
  var startDiff = startTime - program.startTime;
  var startDistance = startDiff / (endTime - startTime);
  var programStartX = coordinate.x - startDistance;
  var endDiff = startTime - program.endTime;
  var endDistance = endDiff / (endTime - startTime);
  var programEndX = coordinate.x - endDistance;
  return {
    xFrom: programStartX,
    xTo: programEndX
  };
};

/**
 * Mapping a channel index to a coordinate
 * grid Y range (```{ yFrom, yTo }```)
 * Using the current coordinate to calculate where
 * we are in the global grid.
 *
 * @param {number} channelIndex The index of the channel to map
 * @param {object} range The total range
 * @param {object} coordinate The current coordinate
 * @returns {object} The coordinate grid Y range (```{ yFrom, yTo }```)
 *                   for the given channel index.
 */
exports.getProgramRange = getProgramRange;
var getChannelRange = function getChannelRange() {
  var channelIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var range = arguments.length > 1 ? arguments[1] : undefined;
  var coordinate = arguments.length > 2 ? arguments[2] : undefined;
  var yFrom = range.yFrom,
    yTo = range.yTo;
  var channelStep = 1 / (yTo - yFrom || 1);
  return {
    yFrom: coordinate.y + channelIndex * channelStep,
    yTo: coordinate.y + (channelIndex + 1) * channelStep
  };
};
exports.getChannelRange = getChannelRange;